<template>
  <div class="number-input-component">
    <div
      class="number-input-component__button"
      :class="{'number-input-component__button--inactive' : Number(input.value) === Number(min) }"
      @click="decrease()">
      {{ t.decrease }}
    </div>
    <input
      ref="inputField"
      v-model="input.value"
      class="number-input-component__input"
      :data-max="max"
      :data-min="min"
      type="text"
      @blur="onBlur()"
      @keyup="keyup($event)" />
    <div
      class="number-input-component__button"
      :class="{'number-input-component__button--inactive' : Number(input.value) === Number(max) }"
      @click="increase()">
      {{ t.increase }}
    </div>
  </div>
</template>

<script>
  import TIcons from '../../../types/TIcons';

  export default {
    data() {
      return {
        cooldown: null,
        icons: TIcons,
        input: {
          backup: 0,
          value: 0,
        },
        lastSend: null,
      };
    },
    props: {
      eventDelay: {
        default: 0,
        type: Number,
      },
      max: {
        default: 100,
        type: Number,
      },
      min: {
        default: 1,
        type: Number,
      },
      t: {
        default: () => {
          return {
            decrease: `-`,
            increase: `+`,
          };
        },
        type: Object,
      },
      value: {
        default: 1,
        type: [Number, String],
      },
    },
    mounted() {
      this.input.value = this.value.toString();
      this.input.backup = this.value.toString();
      this.lastSend = this.value.toString();
    },
    methods: {
      checkValue() {
        const reg = /^\d+$/;
        const isInteger = reg.test(this.input.value);
        if(!isInteger && this.input.value.length > 0) {
          this.input.value = this.input.backup;
        }
        if(this.input.value.length > 0) {
          this.input.backup = Number(this.input.value);
        }
        if(this.input.backup !== this.input.value && this.input.value.length > 0) {
          if(this.emitChange === 0) {
            this.emitIncrease();
            return;
          }
          this.setCooldown(this.emitChange);
        }
      },
      decrease() {
        if(this.input.value <= this.min) {
          return;
        }
        this.input.value--;
        this.input.value = this.input.value.toString();
        this.input.backup = this.input.value;
        if(this.eventDelay === 0) {
          this.emitDecrease();
          return;
        }
        this.setCooldown(this.emitDecrease);
      },
      emitChange() {
        this.$emit(`change`, Number(this.input.value));
      },
      emitDecrease() {
        this.$emit(`change`, this.input.value);
        this.$emit(`decrease`, this.input.value);
      },
      emitIncrease() {
        this.$emit(`change`, this.input.value);
        this.$emit(`decrease`, this.input.value);
      },
      increase() {
        if(this.input.value >= this.max) {
          return;
        }
        this.input.value++;
        this.input.value = this.input.value.toString();
        this.input.backup = this.input.value;
        if(this.eventDelay === 0) {
          this.emitIncrease();
          return;
        }
        this.setCooldown(this.emitIncrease);
      },
      keyup(event) {
        switch(event.keyCode) {
          case 38:
            this.increase();
            break;
          case 40:
            this.decrease();
            break;
          default:
            this.checkValue();
            break;
        }
      },
      onBlur() {
        if(this.input.value.length === 0) {
          this.input.value = this.input.backup;
        }
        this.setCooldown(this.emitChange);
      },
      setCooldown(_callback) {
        if(this.cooldown !== null) {
          clearTimeout(this.cooldown);
          this.cooldown = null;
        }
        this.cooldown = setTimeout(() => {
          clearTimeout(this.cooldown);
          if(this.input.value === this.lastSend) {
            return;
          }
          this.cooldown = null;
          this.lastSend = this.input.value;
          _callback();
        }, this.eventDelay);
      },
    },
    watch: {
      value(val) {
        this.input.value = val.toString();
        this.input.backup = val.toString();
        this.lastSend = val.toString();
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/styles/rin-variables.less';

  .number-input-component {
    display: inline-block;

    &__button,
    &__input {
      display: inline-block;
    }

    &__input {
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      width: calc(100% - 50px);
    }

    &__button {
      box-sizing: border-box;
      color: #000;
      cursor: pointer;
      font-family: inherit;
      font-size: .90909rem;
      font-weight: 400;
      height: 2.30682rem;
      line-height: 1.6;
      margin: 0 0 .90909rem 0;
      padding: .45455rem;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
      width: 20px;

      &--inactive {
        color: #ccc;
        cursor: default;
      }
    }
  }
</style>
